import { render, staticRenderFns } from "./emailRegistrazione.vue?vue&type=template&id=15cc2251&"
import script from "./emailRegistrazione.vue?vue&type=script&lang=js&"
export * from "./emailRegistrazione.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports